import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle, Spinner } from "@florisoft/ui"

export interface BootProgressProps {
  /** What is being done for the author, for example "Opening inventory". */
  readonly title: string
  /** The stage the work is in. */
  readonly stage: string
}

/** What the author sees while the Prototyper starts or a prototype opens: the work in progress and its current stage. */
export function BootProgress({ title, stage }: BootProgressProps) {
  return (
    <Empty live>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Spinner />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{stage}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  )
}
